module.exports = __webpack_public_path__ + "media/campanitas.d6151af5.mp3";